export default __webpack_public_path__ + "static/media/layer-autodrive-box.36e63e60.svg";